import request from '@/utils/request'

export function getContractImgsApi(fileId) {  // 获取合同图片
  return request({
    url: '/contract/getPng?fileId='+fileId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function contractEditApi(data) { // 保存草稿 && 发起签约
  return request({
    url: '/contract/edit',
    method: 'post',
    data
  })
}

// export function loadAuthCompanyListApi(data) {  // 根据phone和name获取企业名称
//   return request({
//     url: '/contract/formalCompanyNameList?phone='+data.phone+'&name='+data.name+'&nocache='+new Date().getTime(),
//     method: 'get'
//   })
// }

export function getContractInfoApi(contractId) {
  return request({
    url: '/contract/get?contractId='+contractId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function getContactListApi() {
  return request({
    url: '/contact/list?nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function getAccountInfoApi(params) {  //
  return request({
    url: '/contract/vallidateContactUser',
    method: 'get',
    params
  })
}

export function downloadTemplateApi(formworkId) {
  return request({
    url: '/contract/downloadFormwork?formwork='+formworkId+'&nocache='+new Date().getTime(),
    method: 'get',
    responseType: 'blob'
  })
}

export function queryContactAgentUserApi(companyId) {
  return request({
    url: '/contract/queryContactAgentUser?contactUserId='+companyId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function getContractTypeApi(tenantId) {
  return request({
    url: '/tbContractType/getAllList?tenantId='+tenantId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function validateContactAgentUserApi(params) {
  return request({
    url: '/contract/validateContactAgentUser',
    method: 'get',
    params
  })
}

export function queryContactTagApi(params) {
  return request({
    url: '/contract/queryContactTag',
    method: 'get',
    params
  })
}

export function getContractSignListApi(params) {
  return request({
    url: '/contract/getContractSignList',
    method: 'get',
    params
  })
}

export function downloadTemplateBatchApi(data) {
  return request({
    url: '/contractBatch/downloadTemplate ',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export function getUserApi(data) {
  return request({
    url: '/contractH5/getUserList',
    method: 'post',
    data
  })
}

export function getContractSignStatusApi(data) {
    return request({
      url: '/contract/getContractSignStatus',
      method: 'post',
      data
    })

}
